import { Box, Typography, Button, Modal, Backdrop, useTheme } from "@mui/material";
import { FREE_TIER_TICKER } from "../../contexts/MembershipContext";

interface WelcomeModalProps {
  open: boolean;
  onDismiss: () => void;
}

export const WelcomeModal = ({ open, onDismiss }: WelcomeModalProps) => {
  const theme = useTheme();

  return (
    <Modal
      open={open}
      onClose={onDismiss}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
          sx: {
            backgroundColor:
              theme.palette.mode === "dark"
                ? "rgba(0, 0, 0, 0.7)"
                : "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(4px)",
          },
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 480 },
          bgcolor: "background.paper",
          borderRadius: 3,
          border:
            theme.palette.mode === "dark"
              ? "1px solid rgba(255, 255, 255, 0.1)"
              : "1px solid rgba(0, 0, 0, 0.1)",
          outline: "none",
          p: { xs: 3, sm: 4 },
          textAlign: "center",
        }}
      >
        <Box sx={{ mb: 3, display: "flex", justifyContent: "center" }}>
          <Box
            component="img"
            src="/insightLongLogoPrimaryWhiteText.svg"
            alt="Insight Analytics Logo"
            sx={{
              height: { xs: 32, sm: 40 },
              width: "auto",
              maxWidth: 240,
            }}
          />
        </Box>

        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            mb: 1.5,
            color: theme.palette.text.primary,
            fontSize: { xs: "1.25rem", sm: "1.5rem" },
          }}
        >
          Welcome to Insight
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: theme.palette.text.secondary,
            mb: 1,
            lineHeight: 1.6,
            fontSize: { xs: "0.875rem", sm: "1rem" },
          }}
        >
          You can explore the free version of Insight to see how our
          AI-powered investment research works.
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            mb: 3,
            lineHeight: 1.6,
          }}
        >
          We've added{" "}
          <Typography
            component="span"
            sx={{ fontWeight: 700, color: theme.palette.primary.main }}
          >
            Nvidia
          </Typography>{" "}
          to your watchlist as an example of how analysis looks across the full
          version of the app.
        </Typography>

        <Button
          variant="contained"
          fullWidth
          onClick={onDismiss}
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            fontWeight: 600,
            py: 1.5,
            borderRadius: 2,
            textTransform: "none",
            fontSize: "1rem",
            "&:hover": {
              backgroundColor: theme.palette.primary.dark,
            },
          }}
        >
          Get Started
        </Button>
      </Box>
    </Modal>
  );
};
